// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"bex_a bhv_sl","StrollerBoxWidget__imageCounselling":"bex_b bhv_jz"};